export const selectStyle = (isMobileView) => {
  return {
    input: (provided) => ({
      ...provided,
      borderRadius: 0,
      width: 0,
      padding: '0px',
      margin: '0px',
      outline: 'none',
      boxShadow: 'none',
      '& input': {
        outline: 'none !important',
        boxShadow: 'none !important',
        border: 'none !important',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      padding: '0px',
      margin: '0px',
    }),
    placeholder: (provided) => ({
      ...provided,
      margin: '0px',
      left: '-2px',
      color: '#999',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0px',
      margin: '0px',
    }),
    indicatorContainer: (provided) => ({
      ...provided,
      padding: '12px',
    }),
    option: (provided, state) => ({
      ...provided,
      padding: isMobileView ? '6px' : '10px',
      cursor: 'pointer',
      color: '#000000',
      backgroundColor: state.isFocused && '#ebedef',
    }),
    control: (provided, state) => ({
      ...provided,
      padding: isMobileView ? '6px' : '12px',
      minHeight: '20px',
      boxShadow: 'none',
      borderColor: '#d4d7dc',
      borderWidth: '1px',
      borderRadius: '0rem',
      backgroundColor: state.isDisabled ? '#F9FAFB' : provided.backgroundColor,
    }),
  };
};
